module.exports = __webpack_public_path__ + "media/images/ecalls/icon_circle_orange-4b92d038c4a0e6fd249ec6f92000ee27.png";